import { render, staticRenderFns } from "./ClientTrialExtendRequest.vue?vue&type=template&id=01652dd2"
import script from "./ClientTrialExtendRequest.vue?vue&type=script&lang=js"
export * from "./ClientTrialExtendRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports